<template>
  <v-card>
    <v-img :src="require('@/assets/background.svg')" :min-height="$vuetify.breakpoint.xs ? '100vh' : '0'">
      <v-card-text
        class="headline text-xs-center secondary--text font-weight-medium"
      >Políticas de Privacidade Apetrus</v-card-text>
      <template v-if="!loading">
        <v-card-text
          id="scroll-target-politicas"
          v-html="politicasDePrivacidade.texto"
          v-if="politicasDePrivacidade"
          v-scroll:#scroll-target-politicas="onScroll"
          class="scroll-y"
          :style="{ maxHeight: $vuetify.breakpoint.xs ? 'calc(100vh - 150px)' : '600px'}"
        ></v-card-text>
        <v-footer absolute color="transparent" class="pb-3">
          <v-btn flat color="grey darken-2" @click="fechar()">VOLTAR</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            flat
            color="secondary"
            @click="confirmarLeitura()"
          >CONFIRMAR LEITURA</v-btn>
        </v-footer>
      </template>
      <template v-else>
        <v-layout fill-height justify-center align-center>
          <v-progress-circular indeterminate size="250" color="primary"></v-progress-circular>
        </v-layout>
      </template>
    </v-img>
  </v-card>
</template>

<script>
export default {
  data () {
    return {
      confirmarDisabled: true
    }
  },
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    politicasDePrivacidade () {
      return this.$store.getters.politicasDePrivacidade
    }
  },
  mounted () {
    this.carregarPoliticas()
  },
  methods: {
    carregarPoliticas () {
      this.$store.dispatch('carregarPoliticasDePrivacidade')
    },
    onScroll (e) {
      if (
        e.target.scrollTop ===
        e.target.scrollHeight - e.target.offsetHeight
      ) {
        this.confirmarDisabled = false
      }
    },
    fechar () {
      this.confirmarDisabled = true
      this.$emit('fechar')
    },
    confirmarLeitura () {
      this.$emit('confirmarLeitura')
      this.fechar()
    }
  }
}
</script>
